var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA2ElectricalDiagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 27h-5v-4h14v4h-5v9h-4v-9zm0 27h4v-9.81l-8.09-6.8-2.51 3.07 6.6 5.6V54zm32-41v49H7V27.22L20.57 13H69zm-4 4H22v12H11v29h54V17z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A2_Electrical_Diagram.b2743c82.svg";
export { SvgA2ElectricalDiagram as ReactComponent };